<template>
  <div class="fix-container">
    <section class="intro">
      <div class="intro__content">
        <div class="intro__content-title">
          Запишись на перевозку в&nbsp;три клика
        </div>
        <div class="intro__content-description">
          Запись через приложение быстрее,<br> чем по телефону.<br> Платим в день сдачи ТТН.
        </div>
        <new-button
          title="Войти/зарегистрироваться"
          type="primary"
          width="fullWidth"
          @button-clicked="$router.push('/login')"
        />
      </div>
    </section>
  </div>
</template>

<script>
import NewButton from '@/components/Drivers/NewButton/NewButton'
export default {
  name: 'Intro',
  components: {
   NewButton,
  },
}
</script>
<style lang="sass" scoped>
.fix-container
  position: fixed
  top: 0
  bottom: 0
  left: 0
  right: 0

  .intro
    background-image: url('~@/assets/img/new-main-img-mobile.png')
    background-size: cover
    background-repeat: no-repeat
    padding: 5rem 3rem
    width: 100%
    height: 100%
    display: flex
    flex-direction: column
    justify-content: flex-end
    @media (min-width: 768px)
      background-image: url('../../assets/img/new-main-img-desktop.jpg')
    &__content
      max-width: 600px
      margin: 0 auto
      font-family: 'Mulish', sans-serif
      color: #FFFFFF
      &-title
        margin-bottom: 2.1rem
        font-size: 3.8rem
        line-height: 4.3rem
        font-weight: 800
      &-description
        margin-bottom: 4.5rem
        font-size: 1.6rem
        line-height: 2rem
        font-weight: 400
</style>
